import { defineComponent as _defineComponent } from 'vue'
import CardContainer from '@/components/card-container.vue';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { ImageLoader } from '@tencent/wphk-components-content-loader';
import { MerchantFavorites, MerchantSubscribe } from '@tencent/wphk-components-merchant-favorites';
import { useMerchantInfo } from '../../../../store/merchant-info-module';
import ShareIcon from './share-icon.vue';
import { i18n } from '@/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'merchant-info',
  props: {
    name: null,
    logo: null
  },
  setup(__props: any) {


const { getBiExt } = useGlobalBi();
const { spId } = useMerchantInfo();
const subTplInfo = [{
  id: 'subc.wecoupon_online_notify',
  tplId: 'Vp0eojT1lEUceQjBZPwMy0LlGMCSaC4_hEDmCdDr9Vs',
}];
const ariaShareText = i18n('立即share畀朋友');

return { __sfc: true,getBiExt, spId, subTplInfo, ariaShareText, CardContainer, ImageLoader, MerchantFavorites, MerchantSubscribe, ShareIcon }
}

})